import * as React from 'react';

type Props = {
  left: any;
  right: any;
  middle?: any;
  tdClassName?: string;
};

const Row: React.FunctionComponent<Props> = (props: Props) => {
  const { left, middle, right, tdClassName } = props;
  return (
    <tr>
      <th>{left}</th>
      {!!middle && <th>{middle}</th>}
      <td className={tdClassName}>{right}</td>
    </tr>
  );
};

export default Row;
